import React from 'react'

import TitleHolder from '../shared/TitleHolder/TitleHolder'
import QbHeading from '../shared/QbHeading/QbHeading'
import QbInput from '../shared/QbInput/QbInput'
import QbLink from '../shared/QbLink/QbLink'
import QbButton from '../shared/QbButton/QbButton'
import { RESTORE_WALLET_NAV } from '../../constants/navigation'

const UnlockWallet = ({
  t,
  unlockProfile,
  onPasswordChange,
  unlockWallet
}) => (
  <div className="main-content-container">
    <TitleHolder title={t('wallet.unlock.title')}/>

    <div className="main-content-body">
      <QbHeading title={t('wallet.unlock.headline')} text={t('wallet.unlock.message')}/>

      <div className="title-input-button">
        
        <QbInput
          type="password"
          value={unlockProfile.password}
          title={t('wallet.unlock.enter-password-label')}
          onChange={onPasswordChange}
          errorMessage={t(unlockProfile.error)}
          onKeyDown={event => { if (event.keyCode === 13) unlockWallet() }}
        />

        <div className="main-content-footer">
          <QbLink name={t('nav.restore-wallet-2')} to={RESTORE_WALLET_NAV}/>
          <QbButton name="Unlock wallet" onClick={() => unlockWallet()}/>
        </div>

      </div>

    </div>
  </div>
)

export default UnlockWallet



// WEBPACK FOOTER //
// ./src/components/UnlockWallet/UnlockWallet.js